<div class="signup-card w-full !py-0 [&>.p-card-body]:!py-0">
  <div class="mb-3">
    <h2 class="text-2xl lg:text-3xl font-semibold text-gray-800 headerStyling">
      {{ i18n.t('createYourAccount') }}
    </h2>
  </div>

  <form [formGroup]="CreateAccountForm" class="flex flex-col space-y-4 min-h-[400px]">
    <!-- Name -->
    <app-input formControlName="name" labelCustomClass="block mb-1 font-medium text-gray-700 labelInputClass"
      inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full labelInputClass"
      [label]="i18n.t('name')" [placeholder]="i18n.t('enterYourName')" [submitted]="submitted"></app-input>

    <!-- Email -->
    <app-input formControlName="email" labelCustomClass="block mb-1 font-medium text-gray-700 labelInputClass"
      inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full labelInputClass"
      [label]="i18n.t('email')" secondaryLabel="{{ i18n.t('willBeUsedAsUsernameForLogin') }}" [submitted]="submitted"
      [placeholder]="i18n.t('enterYourEmail')"></app-input>

    <!-- Country Code & Mobile -->
    <div class="flex gap-4">
      <!-- Country Code Dropdown -->
      <app-dropdown [label]="i18n.t('country')" formControlName="countries" [options]="countries" optionLabel="name"
        optionValue="id" [placeholder]="i18n.t('select')"
        labelCustomClass="block mb-1 font-medium text-gray-700 labelInputClass"
        inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full labelInputClass"
        showClear="true" class="w-2/5" [submitted]="submitted" [filter]=true (changed)="onCountryChange($event)"
        [isVirtualScroll]="true">
        <ng-template #selectedItem let-country>
          <div class="flex items-center gap-2">
            <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
              [class]="'flag flag-' + country.code?.toLowerCase()" style="width: 18px" />
            <div>{{ country.name }}</div>
          </div>
        </ng-template>
        <ng-template #item let-country>
          <div class="flex items-center gap-2">
            <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
              [class]="'flag flag-' + country.code?.toLowerCase()" style="width: 18px" />
            <div>{{ country.name }}</div>
          </div>
        </ng-template>
      </app-dropdown>

      <!-- Mobile Input -->
      <app-input type="phone" formControlName="mobile" [label]="i18n.t('phoneNumber')"
        labelCustomClass="block mb-1 font-medium text-gray-700 labelInputClass"
        inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full labelInputClass"
        [placeholder]="i18n.t('enterYourMobileNumber')" class="w-3/5" [submitted]="submitted"
        [phoneCode]="selectedCountry?.phoneCode" [countryCode]="selectedCountry?.code"></app-input>
    </div>

    <app-password formControlName="password" [label]="i18n.t('password')" [submitted]="submitted" [showValidationHints]="true"
      labelCustomClass="block mb-1 font-medium text-gray-700"
      inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full"></app-password>

    <div class="text-sm text-gray-600 tracking-tight space-y-3">
      <p>
        {{ i18n.t('personalDetailsMessage') }}
      </p>

      <p>{{ i18n.t('agreeAndContinueMessage') }}</p>
    </div>
    <div class="mt-auto items-center w-full">
      <app-button [label]="i18n.t('agreeAndContinue')" type="button" severity="info"
        customClass="wideButton w-full custom-dark-blue" size="large" (click)="onLogin()"></app-button>
    </div>
  </form>
</div>